export const PRIMARY = '#FC4C02';

export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
